import { Box, Typography } from "@mui/material";
import { keyframes } from "@mui/system";
import React from "react";
import PropTypes from "prop-types";

/* type StampType = "REJETE" | "VOLE" | "MALADIE_DECLAREE";

interface AdminStampProps {
  type: StampType;
} */

const stampAnimation = keyframes`
  0% {
    transform: scale(3) rotate(-25deg);   
    opacity: 0;
  }
  60% {
    transform: scale(0.9) rotate(-10deg);
    opacity: 1;
  }
  80% {
    transform: scale(1.05) rotate(-12deg);
  }
  100% {
    transform: scale(1) rotate(-12deg);
  }
`;

/* const getColor = (type) => {
  switch (type) {
    case "REJETE":
      return "#c62828";
    case "VOLE":
      return "#6a1b9a";
    case "MALADIE_DECLAREE":
      return "#ef6c00";
    default:
      return "#c62828";
  }
};

const getLabel = (type) => {
  switch (type) {
    case "REJETE":
      return "REJETÉ";
    case "VOLE":
      return "VOLÉ";
    case "MALADIE_DECLAREE":
      return "MALADIE DÉCLARÉE";
    default:
      return "";
  }
}; */

const StampComponent = ({ label }) => {
  // const color = getColor(type);
  const color = "#c62828";
  // console.log("dddd", label);

  return (
    <Box
      sx={{
        position: "fixed", // sticky on scroll
        // top: { xs: 150, md: 550 }, // responsive top offset
        // right: { xs: 20, md: 40 }, // you can choose left or right
        top: { xs: 350, md: 550 }, // vertical offset
        left: "50%", // horizontally center
        zIndex: 9999, // above everything
        pointerEvents: "none", // does not block clicks
      }}
    >
      <Box
        sx={{
          // border: `6px solid ${color}`,
          borderRadius: "30%",
          width: { xs: 180, md: 260 },
          height: { xs: 180, md: 260 },
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          animation: `${stampAnimation} 600ms ease-out`,
          background: "rgba(255,255,255,0.05)",
          boxShadow: `0 0 20px ${color}55`,
        }}
      >
        <Typography
          sx={{
            color,
            fontWeight: 900,
            fontSize: { xs: 20, md: 28 },
            textAlign: "center",
            textTransform: "uppercase",
            letterSpacing: 3,
            px: 2,
          }}
        >
          {/* getLabel(type) */}
          Alerte <br />
          {label}
        </Typography>
      </Box>
    </Box>
  );
};

export default StampComponent;
StampComponent.propTypes = {
  label: PropTypes.string.isRequired,
};
